import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  styled,
} from "@mui/material";
import { FormLabel } from "components";
import { useSelector } from "react-redux";

const RadioButtonInput = ({
  label,
  options,
  optionKey,
  optionLabel,
  value,
  onChange,
  size,
  color,
  row,
  required,
}) => {
  const userState = useSelector(state => state?.userState);
  const theme = userState?.publisher?.theme_color;
  return (
    <FormControl>
      {label && <FormLabel label={label} required={required} />}
      <RadioGroup value={value} onChange={onChange} row={row}>
        {options?.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option?.[optionKey]}
            control={<CustomRadio size={size} customColor={color || theme} />}
            label={option?.[optionLabel]}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

const CustomRadio = styled(Radio)(({ customColor }) => ({
  "&.MuiRadio-root": {
    "&.Mui-checked": {
      color: customColor || "#111827",
    },
  },
}));

export default RadioButtonInput;
